import AccessControlProfiles from '../components/templates';

export const AccessControlProfilesContainer = () => {
  return <AccessControlProfiles />;
};
